import React from "react";
import { useConfiguratorContext } from "@studio3dx/legacy-use-configurator/react";
import EnquiryDialog from "./EnquireDialog";
import SaveCodeDialog from "./SaveCodeDialog";

interface ConfigurationSummaryProps {
  totalPrice: number;
}

export const ConfigurationSummary: React.FC<ConfigurationSummaryProps> = ({
  totalPrice,
}) => {
  const { configuratorName } = useConfiguratorContext();

  const standardEquipment = [
    "Navigation lights & compass",
    "Stainless steel cleats & fittings",
    "Fiat 500 inspired dashboard",
    "Integrated swim platform",
    "Retractable sunshade canopy",
    "Marine-grade audio system",
  ];

  return (
    <div
      id="summary"
      className=" mt-8 w-full p-6 flex flex-col items-center gap-6 bg-white border border-gray-200 hover:border-black/20 transition-all duration-300"
    >
      {/* Standard Equipment Section */}
      <div className="w-full">
        <h2 className="text-lg md:text-xl text-black mb-4">
          STANDARD EQUIPMENT
        </h2>
        <ul className="space-y-2">
          {standardEquipment.map((item, index) => (
            <li key={index} className="flex items-start">
              <span className="w-2 h-2 bg-gray-400 rounded-full mt-2 mr-3 flex-shrink-0"></span>
              <span className="text-sm text-gray-700">{item}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Buttons Section */}
      <div className="w-full flex flex-col gap-3">
        {/* Request Quotation & Enquiry Button */}
        <div className="w-full">
          <EnquiryDialog />
        </div>

        {/* Save Config Button */}
        <div className="w-full">
          <SaveCodeDialog />
        </div>
      </div>

      {/* Disclaimer Text */}
      <p className="text-xs text-gray-500 text-center leading-relaxed max-w-lg">
        Final specifications may vary. Please contact our team for detailed
        technical information and delivery timelines. All configurations subject
        to availability.
      </p>
    </div>
  );
};
